<template>
  <v-container fluid fill-height class="back" :style="getBackSize">
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm8 md6 lg4 xl3>
        <!-- sporočilo ob zagonu app-a iz FB ali Instagrama -->
        <v-card
          v-if="this.$store.state.fbApp"
          outlined
          :style="
            getTheme() == 'dark'
              ? 'border-color: darkgray; background-color: gray'
              : 'border-color: whitesmoke; background-color: gainsboro'
          "
          class="pa-1"
        >
          <v-card-title>{{
            $store.state.storeClient.client.basicSettings.fullName
          }}</v-card-title>
          <v-card-text>{{ $t("lmSignInFacebookInfo") }}</v-card-text>
          <v-card-text class="primary white--text">{{
            $t("lmSignInFacebookInfo2")
          }}</v-card-text>
        </v-card>
        <!-- LOGIN WINDOW -->
        <v-card
          v-else
          outlined
          :style="
            getTheme() == 'dark'
              ? 'border-color: darkgray; background-color: gray'
              : 'border-color: whitesmoke; background-color: gainsboro'
          "
          class="pa-1"
        >
          <v-toolbar dark color="primary" class="font-weight-normal">
            <v-img
              @click="appUpdate()"
              style="max-height: 32px; max-width: 32px"
              :src="
                $store.state.storeClient.client.loginSettings.logoLink.length >
                0
                  ? $store.state.storeClient.client.loginSettings.logoLink
                  : defaultAppLogo
              "
            ></v-img>
            <v-spacer></v-spacer>
            <v-toolbar-title>
              {{ $store.state.storeClient.client.basicSettings.fullName }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- IZBIRA JEZIKA MENU -->
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn fab small text dark v-on="on">
                  <v-icon>mdi-flag</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in flagItems"
                  :key="index"
                  @click="changeLang(item.langShort)"
                >
                  <v-list-item-avatar>
                    <img :src="item.avatar" />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-card
            flat
            :style="
              getTheme() == 'dark'
                ? 'border-top: 1px solid darkgray'
                : 'border-bottom 1px solid darkgray;'
            "
          >
            <v-img
              :src="
                $store.state.storeClient.client.loginSettings.image
                  ? defaultRandomMainLoginImage
                  : $store.state.storeClient.client.loginSettings
                      .imageStorageLink.length > 0
                  ? $store.state.storeClient.client.loginSettings
                      .imageStorageLink
                  : loginMainCardImage
              "
              class="align-end"
            >
              <div
                v-if="
                  $store.state.storeClient.client.loginSettings.clientPunchline
                    .length > 0
                "
                class="ma-3 text-center overline"
              >
                <span
                  class="pa-1"
                  style="
                    color: white;
                    background: linear-gradient(
                      rgba(0, 0, 0, 0.4),
                      rgba(0, 0, 0, 0.4)
                    );
                  "
                >
                  {{
                    $store.state.storeClient.client.loginSettings
                      .clientPunchline
                  }}
                </span>
              </div>
            </v-img>
            <v-card
              :style="
                getTheme() == 'dark'
                  ? 'border-top: 1px solid darkgray; background-color: #303030'
                  : 'border-top: 1px solid darkgray; background-color: whitesmoke'
              "
            >
              <v-progress-linear
                v-show="loading"
                color="primary"
                height="10"
                indeterminate
              ></v-progress-linear>
              <div
                class="caption px-4 pt-4 font-weight-light text-center"
                :class="getTheme() == 'dark' ? 'white--text' : 'black--text'"
              >
                <div v-if="loading">{{ $t("lmSignInLoadingMessage") }}</div>
                <div v-else>
                  <span
                    v-if="
                      $store.state.storeClient.client.loginSettings
                        .welcomeMessage.length > 0
                    "
                  >
                    {{
                      $store.state.storeClient.client.loginSettings
                        .welcomeMessage
                    }}
                  </span>
                  <span v-else>{{ $t("lmSignInWelcomeMessage") }}</span>
                </div>
              </div>
              <div class="d-flex justify-space-around align-center pa-4 pb-8">
                <v-btn large text @click="googleLogin">
                  <div class="d-flex flex-column align-center">
                    <img
                      src="../assets/icons8-google-48.png"
                      style="height: 48px; width: 48px"
                    />
                    <div
                      :class="
                        getTheme() == 'dark' ? 'white--text' : 'black--text'
                      "
                      class="overline"
                    >
                      {{ $t("lmSignInWithGoogleBtn") }}
                    </div>
                  </div>
                </v-btn>
                <v-btn large text @click="facebookLogin">
                  <div class="d-flex flex-column align-center">
                    <img
                      src="../assets/icons8-facebook-48.png"
                      style="height: 48px; width: 48px"
                    />
                    <div
                      :class="
                        getTheme() == 'dark' ? 'white--text' : 'black--text'
                      "
                      class="overline"
                    >
                      {{ $t("lmSignInWithFacebookBtn") }}
                    </div>
                  </div>
                </v-btn>
                <v-btn large text color="white" @click="show = !show">
                  <div class="d-flex flex-column align-center">
                    <img
                      src="../assets/mail.svg"
                      style="height: 46px; width: 46px"
                    />
                    <div
                      :class="
                        getTheme() == 'dark' ? 'white--text' : 'black--text'
                      "
                      class="overline pt-1"
                    >
                      {{ $t("lmSignInWithClassicBtn") }}
                    </div>
                  </div>
                </v-btn>
              </div>
            </v-card>
            <div
              v-show="show"
              style="border: 1px solid whitesmoke; background-color: whitesmoke"
            >
              <v-card-text>
                <v-flex align-center justify-center layout xs12>
                  <v-switch v-model="createNew" inset color="primary">
                    <template slot="label">
                      <span>{{ $t("lmSignInNewUser") }}</span>
                    </template>
                  </v-switch>
                </v-flex>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    prepend-icon="mdi-account-circle"
                    name="email"
                    type="email"
                    v-model="email"
                    :rules="[
                      validateRequired(),
                      validateIsEmail(),
                      validateMaxLength(250),
                    ]"
                    required
                  >
                    <template slot="label">
                      <span>{{ $t("lmFrmEnterEmail") }}</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    prepend-icon="mdi-lock"
                    name="password"
                    id="password"
                    required
                    v-model="password"
                    :rules="[
                      validateRequired(),
                      validatePassword(),
                      validateMaxLength(100),
                    ]"
                    :append-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (e1 = !e1)"
                    :type="e1 ? 'password' : 'text'"
                  >
                    <template slot="label">
                      <span>{{ $t("lmFrmEnterPass") }}</span>
                    </template>
                  </v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions class="pb-3">
                <v-btn color="primary" text @click="resetPassword">
                  <span>{{ $t("lmSignInForgottenPass") }}</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="!valid" @click="signIn">
                  <span>{{ $t("lmSignInLoginBtn") }}</span>
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-card>
        <v-flex xs-12 style="text-align: center" class="pt-2">
          <span
            class="linked"
            v-show="
              $store.state.storeClient.client.rulesAndSecurityInfo
                .showPrivacyInfo
            "
            @click="openPrivacyWindow"
            >{{ $t("lmSignInPrivacyLinkTitle") }}
          </span>
          <span
            v-show="
              $store.state.storeClient.client.rulesAndSecurityInfo
                .showPrivacyInfo &&
              $store.state.storeClient.client.rulesAndSecurityInfo.showRulesInfo
            "
            class="mx-1"
            >|
          </span>
          <span
            class="linked"
            v-show="
              $store.state.storeClient.client.rulesAndSecurityInfo.showRulesInfo
            "
            @click="openRulesWindow"
          >
            {{ $t("lmSignInRulesLinkTitle") }}
          </span>
        </v-flex>
        <div style="text-align: center" class="ma-2 overline">
          &copy;
          <a href="mailto:simon@foto-travnik.si">{{ G_APP_AUTHOR }}</a>
          / ver. {{ $store.getters.appVersion }} /
          <a
            href="https://travnik.myphotopal.shop/privacyPolicy"
            target="_blank"
            >Privacy policy</a
          >
        </div>
      </v-flex>

      <!-- MSG DIALOG -->
      <dialog-basic-msg
        :active="dialogMsg"
        @clickYes="dialogMsg = false"
        icon="mdi-lightbulb-on-outline"
        :title="instructionsTitle"
        :body="instructions"
      ></dialog-basic-msg>

      <v-snackbar
        v-model="$store.state.storeSnackbar.snackbar.active"
        :color="$store.state.storeSnackbar.snackbar.color"
        :timeout="$store.state.storeSnackbar.snackbar.timeout"
        >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
      >
    </v-layout>

    <!-- APP UPDATE CONFIRM DIALOG -->
    <dialog-basic-yes-no
      :active="dialogUpdate"
      @clickYes="appUpdate"
      @clickNo="dialogUpdate = false"
      icon="mdi-cellphone-arrow-down"
      :title="$t('appUpdateDialogTitle')"
      >{{ $t("appUpdateDialogBody") }}</dialog-basic-yes-no
    >
  </v-container>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import { firebaseApp } from "@/firebase";
import { flagLang } from "@/localization/flagLang";
import { G_APP_AUTHOR } from "@/constants";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DialogBasicMsg from "@/components/DialogBasicMsg";

export default {
  name: "login",
  components: { DialogBasicYesNo, DialogBasicMsg },
  data() {
    return {
      loading: false,
      loginMainCardImage: require("@/assets/photoOrderLogin.jpg"),
      defaultAppLogo: require("@/assets/defaultAppLogo.png"),
      defaultRandomMainLoginImage:
        "https://source.unsplash.com/600x300/?" +
        this.$store.state.storeClient.client.loginSettings.imageKeyword,
      valid: false,
      show: false,
      createNew: false,
      email: "",
      password: "",
      flagItems: flagLang,
      e1: true,
      dialogUpdate: false,
      dialogMsg: false,
      instructions: "",
      instructionsTitle: "",
    };
  },
  computed: {
    getBackSize() {
      let returnStr;
      if (this.$store.state.storeClient.client.loginSettings.background.image) {
        returnStr =
          "background-image: url('https://source.unsplash.com/" +
          this.$vuetify.breakpoint.width +
          "x" +
          this.$vuetify.breakpoint.height +
          "/?" +
          this.$store.state.storeClient.client.loginSettings.background
            .imageKeyword +
          "');";

        returnStr +=
          "box-shadow: inset 0 0 0 100vmax rgba(" +
          this.$store.state.storeClient.client.loginSettings.background
            .shadowType +
          ", " +
          this.$store.state.storeClient.client.loginSettings.background
            .shadowType +
          ", " +
          this.$store.state.storeClient.client.loginSettings.background
            .shadowType +
          ", " +
          Number(
            this.$store.state.storeClient.client.loginSettings.background
              .shadowStrength / 100
          ) +
          ");";
      } else {
        returnStr =
          "background-color: " +
          this.$store.state.storeClient.client.loginSettings.background.color;
      }
      return returnStr;
    },
    clientModules() {
      let moduleText = "";
      if (
        this.$store.state.storeClient.client.modules.modulePhotoOrder.active
      ) {
        if (moduleText !== "") {
          moduleText += ", ";
        } else moduleText += " ";
        moduleText += this.$t("lmSignInModulesPhotoOrderString");
      }
      if (moduleText !== "") {
        return moduleText + ".";
      } else return false;
    },
    appAuthor() {
      return G_APP_AUTHOR;
    },
  },
  methods: {
    changeLang(lng) {
      Vue.i18n.set(lng);
      VueCookies.set("lang", lng);
    },
    appUpdate() {
      caches
        .open(
          "myphotopal-precache-v2-https://" +
            this.$store.state.storeClient.client.basicSettings.name +
            ".myphotopal.shop/"
        )
        .then((cache) =>
          cache.keys().then((keys) => {
            for (let key of keys) {
              cache.delete(key);
            }
          })
        );
      location.reload(true);
    },
    openPrivacyWindow() {
      this.instructionsTitle = this.$t("lmSignInPrivacyLinkTitle");
      this.instructions =
        this.$store.state.storeClient.client.rulesAndSecurityInfo.privacyHTML;
      this.dialogMsg = true;
    },
    openRulesWindow() {
      this.instructionsTitle = this.$t("lmSignInRulesLinkTitle");
      this.instructions =
        this.$store.state.storeClient.client.rulesAndSecurityInfo.rulesHTML;
      this.dialogMsg = true;
    },
    async signIn() {
      if (this.$refs.form.validate()) {
        if (this.createNew) {
          this.loading = true;
          let result = await firebaseApp.signUp(this.email, this.password);
          this.loading = false;
          if (result.message) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: result.message, // tukaj ne prevajamo, da izvemo bolj točen vzrok, če je error
            });
          } else {
            this.$router.push("/");
          }
        } else {
          this.loading = true;
          let result = await firebaseApp.signIn(this.email, this.password);
          this.loading = false;
          if (result.message) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: this.$t("lmFrmEnterPassError"),
            });
          } else {
            this.$router.push("/");
          }
        }
      }
    },
    async googleLogin() {
      if (
        this.$store.state.storeClient.client.basicSettings.name !== "undefined"
      ) {
        this.loading = true;
        let result = await firebaseApp.signInGoogle();
        if (result.message) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: result.message, // tukaj ne prevajamo, da izvemo bolj točen vzrok, če je error
          });
          this.loading = false;
        } else {
          this.$router.push("/");
        }
      } else {
        alert("Error!");
      }
    },
    async facebookLogin() {
      if (
        this.$store.state.storeClient.client.basicSettings.name !== "undefined"
      ) {
        this.loading = true;
        let result = await firebaseApp.signInFacebook();
        if (result.message) {
          this.$store.commit({
            type: "showSnackbar",
            color: "error",
            message: result.message, // tukaj ne prevajamo, da izvemo bolj točen vzrok, če je error
          });
          this.loading = false;
        } else {
          this.$router.push("/");
        }
      } else {
        alert("Error!");
      }
    },
    async resetPassword() {
      this.loading = true;
      let result = await firebaseApp.sendNewPassword(this.email);
      this.loading = false;
      if (result.message) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: result.message, // tukaj ne prevajamo, da izvemo bolj točen vzrok, če je error
        });
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("lmSignInResetPassword"),
        });
      }
    },
  },
  async created() {
    this.G_APP_AUTHOR = G_APP_AUTHOR;
    this.$store.dispatch("fbApp");
    await this.$store.dispatch("getLatestVersion");
    if (
      this.$store.getters.appVersion !==
      this.$store.state.storeVersion.latestVersion.latest
    )
      this.dialogUpdate = true;
  },
};
</script>
<style scoped>
.back {
  background-size: cover;
  height: 100vh;
}
a:link {
  color: black;
  text-decoration: none;
}
a:visited {
  color: black;
  text-decoration: none;
}
a:hover {
  color: darkgray;
  text-decoration: none;
}
a:active {
  color: black;
  text-decoration: none;
}
.linked:hover {
  color: white;
  cursor: pointer;
}
</style>
